import { FC } from 'react';
import cn from 'classnames';

import { TRiskLevel } from '@interfaces/riskLevels';

import { IRiskLevelButtonProps } from './RiskLevelButton.interface';

import './style.scss';

const RiskLevelButton: FC<IRiskLevelButtonProps> = ({
  className,
  responsiveLabel,
  riskLevel,
  onClick,
  showLongName = false,
}) => {
  if (!riskLevel) return null;

  return (
    <button
      className={cn(
        'risk-level-button',
        {
          'risk-level-button_level-1': riskLevel.riskLevelId === TRiskLevel.Level1,
          'risk-level-button_level-2': riskLevel.riskLevelId === TRiskLevel.Level2,
          'risk-level-button_level-3': riskLevel.riskLevelId === TRiskLevel.Level3,
          'risk-level-button_responsive-label': responsiveLabel,
        },
        className,
      )}
      title={riskLevel.longName}
      onClick={onClick}
    >
      <img
        src={`/images/img-risk-level-${riskLevel.riskLevelId}.svg`}
        className="risk-level-button__icon"
      />
      <span className="risk-level-button__name risk-level-button__name_full">
        {showLongName ? riskLevel.longName : riskLevel.name}
      </span>
      <span className="risk-level-button__name risk-level-button__name_short">
        {riskLevel.shortName}
      </span>
    </button>
  );
};

export default RiskLevelButton;
